/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.languages').service('LanguagesService', function (
    this: JS5Object,
    _: JS5Object,
    LanguageResourceFactory: JS5Object,
    PaginationService: JS5Object)
{
    const responseHandler = (data: JS5Object, responseHeaders: JS5Function) => {
        PaginationService.parseResponseHeaders(responseHeaders());
        PaginationService.pageData = data;
    };

    this.getAllLanguages = () => {
        let criteria = {
            fetchLimit: -1,
            fetchOffset: 0
        };
        return LanguageResourceFactory.query(criteria).$promise;
    };

    this.getAllLanguagesPaginated = (criteria: JS5Object) => {
        return LanguageResourceFactory.query(criteria, responseHandler).$promise;
    };

    this.getAllLanguagesSorted = () => {
        return this.getAllLanguages().then((allLanguages: JS5Object[]) => {
            const [defaultLanguages, nonDefaultLanguages] = _.partition(allLanguages, { isDefault: true });
            const sortedNonDefaultLanguages = _.sortBy(nonDefaultLanguages, 'name');
            return _.concat(defaultLanguages, sortedNonDefaultLanguages);
        });
    };

    this.createLanguage = (language: JS5Object) => {
        return LanguageResourceFactory.createLanguage(language).$promise;
    };

    this.getLanguage = (languageId: number) => {
        return LanguageResourceFactory.getLanguage({id: languageId}).$promise
    };

    this.updateLanguage = (language: JS5Object) => {
        return LanguageResourceFactory.updateLanguage(language).$promise;
    };

    this.deleteLanguage = (languageId: number) => {
        return LanguageResourceFactory.deleteLanguage({id: languageId}).$promise;
    };
});
